<template>
  <div style="width: 900px; margin: 0 auto; padding-top: 20px;">
    <div class="topbar clearfix">
      <div class="image pull-left">
        <img src="../assets/logo.png" alt="">
      </div>
      <div class="meta pull-left">
        <div class="title">277福利游戏</div>
        <div class="desc">277福利游戏 安全可靠的游戏交易平台</div>
      </div>
    </div>

    <div class="content">
      <div class="app-title">应用描述</div>

      <div class="desc">
        <p>277福利游戏子是集手游资讯，游戏账户交易，游戏攻略，玩家交流互动为一体的游戏媒体资讯与玩家交流平台。</p>
        <p>资讯：第一时间掌握最新资讯攻略，更有新游测评分享游戏玩法与体验。</p>
        <p>交易：玩家相关游戏账户安全交易，交易有保障。</p>
        <p>更多精彩，尽在277福利游戏！</p>
        <p><b>【联系我们】  </b></p>
        <p>反馈邮箱：<b>18049221960@163.com</b></p>
      </div>
    </div>

    <div>
      <div class="app-title">应用截图</div>
      <div class="imgs">
        <div class="img">
          <img src="../assets/banner1.jpg" alt="">
        </div>
        <div class="img">
          <img src="../assets/banner2.jpg" alt="">
        </div>
        <div class="img">
          <img src="../assets/banner3.jpg" alt="">
        </div>
        <!-- <div class="img">
          <img src="../assets/banner4.jpg" alt="277福利游戏">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  }
}
</script>

<style lang="scss">
$imgSize: 90px;
.topbar {
  .image {
    width: $imgSize;
    height: $imgSize;
    border-radius: 6px;
    overflow: hidden;
  }
  .meta {
    font-weight: bold;
    color: #2A2A2A;
    margin-left: 30px;
    .title {
      font-size: 24px;
      margin-top: 3px;
    }
    .desc {
      font-size: 20px;
      color: #636363;
      margin-top: 18px;
    }
  }
}

.app-title {
  font-size: 22px;
  margin: 40px 0;
  color: #2A2A2A;
}

.content {
  .desc {
    font-size: 15px;
    color: #666;
    line-height: 2;
  }
}
.imgs {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .img {
    flex: 1;
    padding: 0 15px;
  }
}
</style>
